import { useCallback } from 'react';

import { modal } from 'shared/components/Modal';
import { MODAL_SIZES } from 'shared/components/Modal/types';

export const useOpenModal = ({
  content,
  props,
  context,
}: {
  content: JSX.Element;
  props: {
    size: MODAL_SIZES;
    title?: string;
  };
  context?: object;
}) =>
  useCallback(
    () => modal.open({ content, props, context }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [content, props.size, props.title, context]
  );
